import React from "react";
import { Tooltip } from "react-tooltip";
import { cuFormat } from "../../../components/table/coreUiTable/Format";
import Table from "../../../components/table/coreUiTable/Table";
import { limitedColHeaders, addGaps } from "../utils/dataForTables";

export const AttritionTable = ({
  chartData: { data = [], columns = [], links = [], attrition_tooltip = "" } = {}
}) => {
  let scopedSlots = {};

  const tooltipForAttrition = (header, value, _, row) => {
    return row[" "] === "Attrition %" ? (
      <>
        <div data-tooltip-html={attrition_tooltip} data-tooltip-id={header + "dailyPulseAttrition"}>
          {value}
        </div>
        <Tooltip id={header + "dailyPulseAttrition"} float />
      </>
    ) : (
      value
    );
  };

  if (data.length > 0) {
    addGaps(data, links);

    scopedSlots = {
      ...cuFormat({
        headers: limitedColHeaders,
        columns,
        links,
        customFn: (header, value, rawValue, line) =>
          tooltipForAttrition(header, value, rawValue, line)
      })
    };
  }

  return (
    <div className="dailyPulse__section dailyPulse__section__row">
      <div className="content">
        <p className="title">Membership & Attrition</p>
        <Table
          table={{ data, colHeaders: limitedColHeaders }}
          pagination={false}
          tableFilter={false}
          tableWrapperId="dailyPulseTable"
          scopedSlots={scopedSlots}
        />
      </div>
    </div>
  );
};
